import React from 'react';
import './Surface.css';

export type SurfaceVariant = 'page' | 'section' | 'nested' | 'muted' | 'flush';
export type SurfacePadding = 'none' | 'sm' | 'md' | 'lg';

export interface SurfaceProps extends React.HTMLAttributes<HTMLElement> {
  as?: keyof JSX.IntrinsicElements;
  variant?: SurfaceVariant;
  padding?: SurfacePadding;
  children?: React.ReactNode;
}

const Surface: React.FC<SurfaceProps> = ({
  as = 'div',
  variant = 'section',
  padding = 'md',
  className = '',
  children,
  ...rest
}) => {
  const Component = as as React.ElementType;
  const classes = [
    'surface',
    `surface--${variant}`,
    `surface--padding-${padding}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Component className={classes} {...rest}>
      {children}
    </Component>
  );
};

export default Surface;
